import { useTour } from '@reactour/tour';

export function useTourStarter() {
  const { setIsOpen, setCurrentStep } = useTour();

  const startTour = (closeMenu?: () => void) => {
    // Check if tour was completed previously
    const tourCompleted =
      localStorage.getItem('samplesTourCompleted') === 'true';

    // If completed from Options menu, start from beginning, otherwise resume
    const startFromOptions = closeMenu !== undefined;
    const startStep =
      startFromOptions && tourCompleted
        ? 0
        : parseInt(localStorage.getItem('samplesTourStep') || '0');

    setCurrentStep(startStep);
    setIsOpen(true);

    // Close menu if function provided (from Options)
    if (closeMenu) {
      closeMenu();
    }
  };

  return { startTour };
}
